import { getPositionOrDerivativePositionType } from '@/lib/positions/positions.js'
import { get } from 'lodash'

export default {
  methods: {
    positionNotCompleted(position) {
      const type = getPositionOrDerivativePositionType(position)
      return (
        !position ||
        !position.type ||
        !position.ticker ||
        !position.currency ||
        (['fund', 'custom'].indexOf(type) === -1 && (!position.country || !position.exchange)) ||
        (position.customDefaultDividendReturnPercent && !position.defaultDividendReturnPercent) ||
        (position.customDefaultDividendOriginRetentionPercent &&
          !position.defaultDividendOriginRetentionPercent) ||
        ((get(position, 'customMarket.active', false) || type === 'custom') &&
          !get(position, 'customMarket.eod.close', 0)) ||
        (type === 'custom' && !position.customType)
      )
    },
  },
}
